<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <div class="btn-group">
          <button type="button" id="btnok" class="btn btn-primary btn-xs" @click="btnok" :disabled="disableInsertBtn">
            <font-awesome-icon :icon="['far', 'save']" />
            {{ translation(10932) }}
          </button>
          <button type="button" id="btncancel" class="btn btn-primary btn-xs" @click="btncancel">
            <font-awesome-icon icon="times" />
            {{ translation(10931) }}
          </button>
        </div>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(11966) }}</span>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblinfo" v-html="translation(11967)"></span>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <fieldset>
          <div class="margin20"></div>
          <XVbootstraprow
            id="lblrol"
            :label="translation(11968)"
            :helptext="translation(11969)"
            class="margin20"
            :required="true"
            :haserror="errors.has('ddrol')"
            :errormessage="errors.first('ddrol')"
            v-if="rollen.length !== 1"
          >
            <XVdropdown
              id="ddrol"
              name="ddrol"
              :datalist="rollen"
              :value="forminputdata.ddlRolSelected"
              @input="selectRol"
              v-if="rollen.length >= 1"
              v-validate="'required'"
              :data-vv-as="translation(11968)"
            ></XVdropdown>
            <span v-html="translation(9377)" v-if="rollen.length === 0"></span>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblprofgroup"
            :label="translation(11970)"
            :helptext="translation(11971)"
            :required="true"
            v-if="cblProfgroups.length !== 0 && selectprofgroups === 2 && forminputdata.ddlRolSelected !== ''"
            :haserror="errors.has('cblprofgroups')"
            :errormessage="errors.first('cblprofgroups')"
          >
            <XVcheckboxlist
              id="cblprofgroups"
              name="cblprofgroups"
              v-model="forminputdata.profgroupsSelected"
              :datalist="cblProfgroups"
              v-validate="'required'"
              :data-vv-as="translation(11970)"
            ></XVcheckboxlist>
          </XVbootstraprow>
          <div
            class="row"
            id="cblprofgroupsempty"
            v-if="cblProfgroups.length === 0 && selectprofgroups === 2 && forminputdata.ddlRolSelected"
          >
            <div class="col-md-4 col-sm-4 col-xs-12">
              <span v-html="translation(11970)"></span>
            </div>
            <div class="col-md-8 col-sm-8 col-xs-12">
              <span v-html="translation(11964)"></span>
            </div>
          </div>
          <XVbootstraprow
            id="lblName"
            :label="translation(11974)"
            :helptext="translation(11975)"
            :required="true"
            :haserror="errors.has('tbxName')"
            :errormessage="errors.first('tbxName')"
          >
            <XVinput
              id="tbxName"
              name="tbxName"
              v-model="forminputdata.tbxName"
              v-validate="'required'"
              :data-vv-as="translation(11974)"
            ></XVinput>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblemail"
            :label="translation(11976)"
            :helptext="translation(11977)"
            :required="true"
            :haserror="errors.has('tbxemail')"
            :errormessage="errors.first('tbxemail')"
          >
            <XVinput
              id="tbxemail"
              name="tbxemail"
              v-model="forminputdata.tbxemail"
              v-validate="'required|email'"
              data-vv-validate-on="change"
              :data-vv-as="translation(11976)"
            ></XVinput>
          </XVbootstraprow>
          <XVbootstraprow
            id="lblDateUpTo"
            :label="translation(11972)"
            :helptext="translation(11973)"
            :required="true"
            :haserror="errors.has('tbxDateUpTo')"
            :errormessage="errors.first('tbxDateUpTo')"
          >
            <XVdate
              id="tbxDateUpTo"
              name="tbxDateUpTo"
              v-model.trim="forminputdata.tbxDateUpTo"
              :data-vv-as="translation(11972)"
              v-validate="{ XVDateDefault: true, required: true }"
            ></XVdate>
          </XVbootstraprow>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
// https://pe.xaurum.nl/peapp/prof/Spe015PrPersonAutorisedAdmin/add
// import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin, util } from 'pevueglobal'
import { sync } from 'vuex-pathify'

export default {
  mixins: [FAMixin],
  data: function () {
    return {}
  },
  async mounted() {
    await this.getRollenProfgroups()
    if (this.rollen.length <= 1) {
      this.setddlRolSelected(this.rollen[0].value)
    }
    this.stopLoading()
  },
  computed: {
    ...mapGetters('Spe015PrPersonAutorisedAdmin', [
      'rollen',
      'selectprofgroups',
      'cblProfgroups',
      'profgroups',
      'disableInsertBtn',
    ]),
    forminputdata: sync('Spe015PrPersonAutorisedAdmin/forminputdata'),
  },
  methods: {
    ...mapActions('Spe015PrPersonAutorisedAdmin', ['getRollenProfgroups', 'insertPerson']),
    ...mapMutations('Spe015PrPersonAutorisedAdmin', ['setddlRolSelected', 'setProfgroupInput', 'setDisableInsertBtn']),
    ...mapMutations(['addNotification']),
    async selectRol(value) {
      await this.setddlRolSelected(value)
      if (this.rollen.length > 1) {
        this.setProfgroupInput()
      }
    },
    btnok() {
      this.$validator.validate().then((result) => {
        if (result) {
          // disable button after click
          this.setDisableInsertBtn(true)
          let rollenInput = ''
          if (this.rollen.length === 1) {
            rollenInput = this.rollen[0].value
            this.setProfgroupInput()
          } else if (this.rollen.length !== 1 && this.rollen.length !== 0) {
            rollenInput = this.forminputdata.ddlRolSelected
          }
          let inputdata = {
            InsTblTypeAdministratorID: rollenInput,
            TblPersonAutorisedAdminDateUpTo: util.DateForDatabase(this.forminputdata.tbxDateUpTo),
            TblPersonAutorisedAdminName: this.forminputdata.tbxName,
            TblPersonAutorisedAdminEmail: this.forminputdata.tbxemail,
            selectprofgroups: this.selectprofgroups,
            profgroups: this.forminputdata.profgroupsSelected,
          }
          this.SaveAndReturn(inputdata)
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    async SaveAndReturn(inputdata) {
      await this.insertPerson(inputdata)
    },
    btncancel() {
      this.$router.push({ path: 'overview' })
    },
  },
}
</script>
